import { TextField, Autocomplete } from "@mui/material";
import React from "react";
import { LoadingProgressBar, LoadingSpinner } from "@rentablo/components";

interface AccountOption {
  id: number;
  name: string;
  bankName?: string;
}

export interface AccountSelectorProps<T extends AccountOption> {
  loading: boolean;
  accounts: T[];
  selectedAccount: T | null;
  placeholder: string;
  testId?: string;
  onSelect: (account: T) => void;
}

export const AccountSelector = <T extends AccountOption>({
  loading,
  accounts,
  selectedAccount,
  placeholder,
  testId,
  onSelect,
}: AccountSelectorProps<T>) => {
  const getOptionLabel = (account: T) =>
    `${account.name} ${account.bankName ? " - " + account.bankName : ""}`;

  const handleSelect = (account: T | null) => {
    if (!onSelect || !account) return;
    onSelect(account);
  };

  if (loading) {
    return <LoadingProgressBar />;
  }
  return (
    <Autocomplete
      getOptionLabel={getOptionLabel}
      loading={loading}
      value={selectedAccount}
      fullWidth
      options={accounts}
      autoHighlight
      isOptionEqualToValue={(option, value) => option.id === value.id}
      onChange={(_: React.SyntheticEvent, value: T | null) => {
        handleSelect(value);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder}
          variant="outlined"
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <LoadingSpinner width={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
              autoComplete: "new-password", // disable autocomplete and autofill
            },

            htmlInput: {
              ...params.inputProps,
              "data-testid": testId ? testId : "account-selector",
            },
          }}
        />
      )}
    />
  );
};
